import { ClassRequestModel, CommonResponse } from "@boi/shared-models";
import { Body, Controller, Post } from "@nestjs/common";
import { DashboardService } from "./dashboard.service";
import { returnException } from "@boi/backend-utils";
import { ApiTags } from "@nestjs/swagger";

@ApiTags("Dashboard")
@Controller("dashboard")
export class DashboardController {
  constructor(private readonly dashboardService: DashboardService) {}

  @Post("getLanguageDistribution")
  async getLanguageDistribution(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getLanguageDistribution(req.classId);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("difficulty-breakdown")
  async getDifficultyBreakdown(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getDifficultyBreakdown();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("subject-difficulty-split")
  async getSubjectDifficultySplit(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getSubjectDifficultySplit(req.classId);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("subjects-wise-distribution")
  async getSubjectsWiseDistribution(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    console.log("dc", req.classId);
    try {
      return await this.dashboardService.getSubjectsWiseDistribution(
        req.classId
      );
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("top-five-by-question-count")
  async getTopFiveByQuestionCount(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getTopFiveByQuestionCount(req.classId);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("class-comparison")
  async getClassComparison(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getClassComparison();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("monthly-additions")
  async getMonthlyAdditions(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getMonthlyAdditions();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("paper-status")
  async getPaperStats(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getPaperStats();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("paper-trend")
  async getPaperTrend(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getPaperTrend();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("overview-stats")
  async getOverviewStats(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getOverviewStats();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("ability-distribution")
  async getAbilityDistribution(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getAbilityDistribution(
        req.classId,
        req.subjectId
      );
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("overall-difficulty-mix")
  async getOverallDifficultyMix(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getOverallDifficultyMix(req.classId);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("sub-ability-distribution")
  async getSubAbilityDistribution(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getSubAbilityDistribution(req.classId);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("blueprint-summary")
  async getBlueprintSummary(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getBlueprintSummary();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("recent-blueprints")
  async getRecentBlueprints(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getRecentBlueprints();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("recent-papers")
  async getRecentQuestionPapers(): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getRecentQuestionPapers();
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post("questions-by-subject")
  async getQuestionsBySubject(
    @Body() req: ClassRequestModel
  ): Promise<CommonResponse> {
    try {
      return await this.dashboardService.getQuestionsBySubject(
        req.classId,
        req.subjectId
      );
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }
}
